module.exports = __webpack_public_path__ + "img/zydk.924162d6.png";